// Common function to apply 3D transform interactions
function apply3DEffect(selector, intensity) {

  const elements = document.querySelectorAll(selector);

  elements.forEach((el) => {
    const height = el.clientHeight;
    const width = el.clientWidth;

    el.addEventListener('mousemove', (e) => {
      const xVal = e.layerX;
      const yVal = e.layerY;

      const yRotation = intensity * ((xVal - width / 2) / width);
      const xRotation = -intensity * ((yVal - height / 2) / height);

      const transform = `perspective(500px) rotateX(${xRotation}deg) rotateY(${yRotation}deg)`;
      el.style.transform = transform;
    });

    el.addEventListener('mouseout', () => {
      el.style.transform = 'perspective(500px) scale(1) rotateX(0) rotateY(0)';
    },120);

    el.addEventListener('mousedown', () => {
      el.style.transform = 'perspective(500px) scale(0.9) rotateX(0) rotateY(0)';
    },120);

    el.addEventListener('mouseup', () => {
      el.style.transform = 'perspective(500px) scale(1.1) rotateX(0) rotateY(0)';
    },120);
  });
}

apply3DEffect('.vayu_block_styling-effect7', 8);

document.addEventListener('DOMContentLoaded', () => {
  const videoBlocks = document.querySelectorAll('.vb-vide-view');

  videoBlocks.forEach(block => {
    const el = block.querySelector('.vb-icon-block-video');
    const poster = block.querySelector('.vb-video-poster');
    const posterwrapper = block.querySelector('.vb-video-wrapper-relative');
    const postercontent = block.querySelector('.vb-video-icon');
    const iframe = block.querySelector('.vb-video-iframe');
    const container = block.querySelector('.vb-video-rotation');
    const youtubev = block.querySelector('.vb-video-iframe-cont');
    const lightboxValue = container?.dataset.lightbox;

    const lightbox = block.querySelector('.vb-vayu-modal');
    const closebutton = block.querySelector('.vb-vayu-modal-close');

    if (!el) return;

    // Click on icon to open video or lightbox
    el.addEventListener('click', () => {
      if (lightboxValue === "true") {
        if (lightbox) {
          lightbox.classList.add('open');
          poster.style.display = 'flex';
          postercontent.style.display = 'flex';
          posterwrapper.style.display = 'block';
          iframe.style.setProperty('display', 'none', 'important');
          document.body.style.overflow = 'hidden';
        }
      } else {
        poster.style.display = 'none';
        if(youtubev){
          youtubev.style.display = 'block';
        }
        postercontent.style.display = 'none';
        posterwrapper.style.display = 'none';
        if(iframe){
          iframe.style.setProperty('display', 'block', 'important');
        }
        document.body.style.overflow = '';
      }
    });

    

    // Close button event inside this block's lightbox
    if (closebutton && lightbox) {
      closebutton.addEventListener('click', () => {
        lightbox.classList.remove('open');
        document.body.style.overflow = '';
      });

      // Clicking outside modal content closes lightbox
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) {
          lightbox.classList.remove('open');
          document.body.style.overflow = '';
        }
      });
    }
  });
});

